"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailDetails = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/no-danger */
var core_ui_1 = require("@newfront-insurance/core-ui");
var lodash_isempty_1 = __importDefault(require("lodash.isempty"));
var react_1 = __importDefault(require("react"));
var date_1 = require("../../lib/date");
function EmailDetails(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var file = _a.file;
    if (!file.meta || (0, lodash_isempty_1.default)(file.meta)) {
        return react_1.default.createElement(core_ui_1.Text, null, "There is no metadata for this email.");
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "space-between", alignItems: "center" },
            react_1.default.createElement(core_ui_1.Text, { size: "large", color: "dark", weight: 600 }, (_b = file === null || file === void 0 ? void 0 : file.meta) === null || _b === void 0 ? void 0 : _b.subject),
            react_1.default.createElement(core_ui_1.Text, null, (0, date_1.longDateTimeFormatWithTimeZone)((_c = file === null || file === void 0 ? void 0 : file.meta) === null || _c === void 0 ? void 0 : _c.emailCreatedAt))),
        react_1.default.createElement(core_ui_1.Padding, { top: 16 },
            react_1.default.createElement(core_ui_1.Text, null,
                "From: ", (_d = file === null || file === void 0 ? void 0 : file.meta) === null || _d === void 0 ? void 0 :
                _d.from),
            react_1.default.createElement(core_ui_1.Text, null,
                "To: ", (_e = file === null || file === void 0 ? void 0 : file.meta) === null || _e === void 0 ? void 0 :
                _e.to),
            ((_f = file === null || file === void 0 ? void 0 : file.meta) === null || _f === void 0 ? void 0 : _f.cc).length > 0 && react_1.default.createElement(core_ui_1.Text, null,
                "Cc: ", (_g = file === null || file === void 0 ? void 0 : file.meta) === null || _g === void 0 ? void 0 :
                _g.cc),
            ((_h = file === null || file === void 0 ? void 0 : file.meta) === null || _h === void 0 ? void 0 : _h.bcc).length > 0 && react_1.default.createElement(core_ui_1.Text, null,
                "Bcc: ", (_j = file === null || file === void 0 ? void 0 : file.meta) === null || _j === void 0 ? void 0 :
                _j.bcc)),
        react_1.default.createElement("div", { className: "email-body", dangerouslySetInnerHTML: { __html: (_k = file === null || file === void 0 ? void 0 : file.meta) === null || _k === void 0 ? void 0 : _k.bodyHtml } })));
}
exports.EmailDetails = EmailDetails;
